// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1h242","footer":"ModalCreateQualiphyProcedure_footer__3396K","additionData":"ModalCreateQualiphyProcedure_additionData__1b4nA"};